import { render } from "./Guideline-add.vue?vue&type=template&id=14981734"
import script from "./Guideline-add.vue?vue&type=script&lang=js"
export * from "./Guideline-add.vue?vue&type=script&lang=js"

import "./Guideline-add.vue?vue&type=style&index=0&id=14981734&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__